<template>
    <el-dialog title="" :visible.sync="visible" :modal-append-to-body="false"  :show-close='false' class="posDio"
        :close-on-click-modal="closeEscape" :close-on-press-escape="closeEscape" width="840px" center>
        <div v-if="step === 1">
            <div class="linkDio-tit" style="text-align:left;">
                Please enter PIN
            </div>
            <div class="pin-input-wrp">
                <input type="password" v-model="pincodes" maxlength="16" @input="pincodes = pincodes.replace(/\s+/g, '')" />
            </div>
            <div class="clear">
                <div class="forget" @click="forget">Forgot PIN?</div>
            </div>
            <div class="btns clear">
                <button class="dark" @click="closeDialog">Cancel</button>
                <button class="light" @click="pinConfirm">Confirm</button>
            </div>
        </div>
        <div v-if="step === 2">
            <div class="linkDio-tit" style="text-align:left;margin-bottom: 10px">
                Did you forget your PIN
            </div>
            <div class="txt-wrp">Click the Yes button and we will send a verification code to your mobile<br />number to
                reset your PIN.</div>
            <div class="btns clear">
                <button class="light" @click="nextToSet" style="float: right">Yes</button>
                <button class="dark" @click="sayNo" style="float: left">No</button>
            </div>
        </div>
        <div v-if="step === 3">
            <div class="linkDio-tit" style="text-align:left">
                Please enter your SMS verification code
            </div>
            <div class="pin-input-wrp" style="margin-bottom: 50px">
                <input type="text" v-model="verificationCode" maxlength="5"
                    @input="verificationCode = verificationCode.replace(/\s+/g, '')" />
            </div>
            <div class="btns clear">
                <button class="dark" @click="closeDialog">Cancel</button>
                <button class="light" @click="validateCode">Next</button>
            </div>
        </div>
        <div v-if="step === 4">
            <div class="linkDio-tit" style="text-align:left">
                Set your new PIN
            </div>
            <div class="pin-input-wrp" style="margin-bottom: 50px">
                <input type="password" v-model="pin" maxlength="16" @input="pin = pin.replace(/\s+/g, '')" />
            </div>
            <div class="btns clear">
                <button class="dark" @click="closeDialog">Cancel</button>
                <button class="light" @click="resetPin">Save</button>
            </div>
        </div>


    </el-dialog>
</template>

<script>
import api from '../../api/login'
import md5 from 'js-md5'

export default {
    name: 'pin',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        closeEscape: {
            default: true
        }

    },
    data() {
        return {
            pincodes: '',
            step: 1,
            sending: false,
            verificationCode: '',
            validating: false,
            pin: '',
            saving: false
        }
    },
    methods: {
        pinConfirm() {
            if (this.pincodes === null) {
                // Utils.alert2('', 'Please enter 4-16 digits', 'error')
                return
            }
                
            const pin = sessionStorage.getItem('pin')
            if (md5(this.pincodes) === pin) {
                this.$emit('receive', 'confirm')
            } else {

                if (this.pincodes.replace(/\s+/g, '').length < 4) {
                    Utils.alert2('', 'Please enter 4-16 digits', 'error')
                    return
                }

                Utils.alert2('', 'Incorrect PIN entered', 'error')

                this.$emit('receive', 'cancel')
            }
        },
        /*pinConfirm () {
            this.$emit('receive', 'confirm')
        },*/
        closeDialog() {
            this.$emit('receive', 'cancel')
        },
        forget() {
            this.step = 2
        },
        sayNo() {
            this.pincodes = ''
            this.step = 1
        },
        nextToSet() {
            this.step = 3
            // 调接口获取验证码
            api.pinNote({
                callback: (res) => {
                    if (res.data.code !== 0) {
                        Utils.alert2('', res.data.message, 'error')
                    }
                }
            })

        },
        validateCode() {
            if (this.verificationCode.replace(/\s+/g, '').length < 5) {
                Utils.alert2('', 'Please enter 5 digits', 'error')
                return
            }
            // 调接口验证
            api.pinCheck({
                params: {
                    code: this.verificationCode,
                    phone: sessionStorage.getItem('userName'),
                    type: 3
                },
                callback: (res) => {
                    if (res.data.code === 0) {
                        this.step = 4
                    } else {
                        Utils.alert2('', res.data.message, 'error')
                    }
                }
            })
        },
        resetPin() {
            if (this.pin.replace(/\s+/g, '').length < 4) {
                Utils.alert2('', 'Please enter 4-16 digits', 'error')
                return
            }

            /*const pin = sessionStorage.getItem('pin')
            if (md5(this.pin) === pin) {
                Utils.alert('','The new PIN cannot be the same as the old PIN!','error')
            }*/


            api.alPin({
                params: {
                    code: this.verificationCode,
                    newPin: this.pin,
                    // oldPin: sessionStorage.getItem('pin')
                },
                callback: (res) => {
                    if (res.data.code === 0) {
                        this.closeDialog()
                        sessionStorage.setItem('pin', md5(this.pin))
                    } else {
                        Utils.alert2('', res.data.message, 'error')
                    }
                }
            })
        }
    },
    watch: {
        'visible': {
            deep: true,
            handler: function (val) {
                this.pincodes = ''
                this.step = 1
                this.sending = false
                this.verificationCode = ''
                this.validating = false
                this.pin = '',
                    this.saving = false
            }
        }

    }
}
</script>

<style lang="scss" scoped>
.linkDio-tit {
    width: 100%;
    text-align: center;
    height: 33px;
    font-size: 24px;
    font-weight: 600;
    color: var(--text-color);
    line-height: 33px;
    margin-bottom: 50px;
}

.txt-wrp {
    margin-bottom: 65px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-color);
    line-height: 28px;
}

.forget {
    float: right;
    cursor: pointer;
    text-decoration: underline;
    margin-bottom: 40px;
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: var(--text-color);
    line-height: 14px;
}

.pin-input-wrp {
    width: 100%;
    position: relative;
    margin-bottom: 20px;

    input {
        outline: none;
        width: 100%;
        background: var(--background-color-2);
        height: 50px;
        box-sizing: border-box;
        border: 1px solid #5F5F5F;
        font-size: 16px;
        padding-left: 15px;
        color: var(--text-color);
    }
}

.btns {
    margin: 0 auto;
    width: 610px;

    button {
        width: 280px;
        height: 60px;
        outline: none;
        background: none;
        cursor: pointer;
        font-weight: 600;
    }

    .dark {
        border: 2px solid var(--text-color);
        color: var(--text-color);
        font-size: 26px;
        float: left;
    }

    .light {
        border: 2px solid #EA3796;
        color: #EA3796;
        font-size: 26px;
        float: right;
    }
}</style>



// WEBPACK FOOTER //
// src/components/common/pin.vue